import React from 'react';
import { cn } from '@/util/cn';
import { Heading } from '@/components/ui/heading';

// Sidebar "At a glance" stat card. A compact dl that pairs a labelled
// row with a right-aligned numeric value — used on the Resort Overview
// sidebar (and intended for the Region Overview sidebar once that page
// gets the same treatment).
//
// Values are React nodes so the consumer can drop a <DistanceUnit /> or
// <SnowUnit /> straight in without pre-formatting.

export interface AtAGlanceStat {
  label: React.ReactNode;
  value: React.ReactNode;
}

export interface AtAGlanceCardProps {
  title: React.ReactNode;
  stats: AtAGlanceStat[];
  className?: string;
}

export const AtAGlanceCard = ({ title, stats, className }: AtAGlanceCardProps) => (
  <section className={cn('rounded-md border border-border bg-card p-4', className)}>
    <Heading level={3} size="base" className="mb-3 font-bold">
      {title}
    </Heading>
    <dl className="m-0 space-y-2 text-sm">
      {stats.map((s, i) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={i}
          className="flex items-baseline justify-between gap-3 border-b border-border py-1.5 last:border-b-0"
        >
          <dt className="text-muted-foreground">{s.label}</dt>
          <dd className="m-0 text-right font-semibold tabular-nums">{s.value}</dd>
        </div>
      ))}
    </dl>
  </section>
);
